module.exports = __webpack_public_path__ + "static/media/forecast-graph-ui.17a9e989.png";